// extracted by mini-css-extract-plugin
export default {"order":"styles_order__doyGZ","title":"styles_title__8B9fv","cardsWrapper":"styles_cardsWrapper__5EVBC"};